import React from "react";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-4 text-center">
      <p className="text-8xl font-black text-orange-100 select-none leading-none mb-2">
        404
      </p>
      <h1 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3">
        Cette page n'existe pas
      </h1>
      <p className="text-slate-500 mb-8 max-w-sm">
        L'adresse que vous avez saisie est introuvable. Elle a peut-être été
        déplacée ou supprimée.
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <button
          onClick={() => navigate("/")}
          className="px-6 py-2.5 bg-orange-600 text-white font-semibold rounded-lg hover:bg-orange-800 transition-colors"
        >
          Retour à l'accueil
        </button>
        <button
          onClick={() => navigate(-1)}
          className="px-6 py-2.5 border border-orange-300 text-orange-600 font-semibold rounded-lg hover:bg-orange-50 hover:border-orange-500 transition-colors"
        >
          Page précédente
        </button>
      </div>
    </div>
  );
}

export default NotFound;
